import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import Navbar from './Navbar';
import BannerSection from './BannerSection';
import test from "../../assets/images/background-img.png";
import { config } from "../../pages/config";
const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50];
const SearchResults = () => {
    const { slug } = useParams();

    const [results, setResults] = useState([]);

    useEffect(() => {
        const fetchResults = async () => {
            try {
                const res = await axios.get(`http://admin.elementeers.com/api/products/search`);
                const filteredProducts = res?.data?.product_details.filter(product =>
                    product.hs_code?.toLowerCase()?.includes(slug.toLowerCase()) ||
                    product.cas_no?.toLowerCase()?.includes(slug.toLowerCase()) ||
                    product.product_name?.toLowerCase()?.includes(slug.toLowerCase())
                );
                console.log(filteredProducts);
                setResults(filteredProducts);
            } catch (err) {
                console.error('Search error:', err);
            }
        };

        if (slug) fetchResults();
    }, [slug]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalPages = Math.ceil(results.length / itemsPerPage);
    const displayedData = results.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    useEffect(() => window.scrollTo(0, 0), [])
    return (
        <div>
            <Helmet>
                <title>Product Search - Elementeers Nucleons</title>
            </Helmet>
            <Navbar inner={true} />
            <div
                className="inner-header bg-holder"
                style={{ backgroundImage: `url(${test})` }}
            >
                <div className="container">
                    <div className="row  justify-content-center">
                        <div className="col-md-12 text-center">
                            <h1 className="title">{"Search Details"}</h1>
                            <p>Search Results for: "{slug}"</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="contact-info-area pb-80">
                <div className="container">
                    <div className="row pt-80 scr-table">
                        <div className="flex justify-between items-center mb-4">
                            <span>Showing {displayedData.length} of {results.length} items</span>
                            <select
                                value={itemsPerPage}
                                onChange={handleItemsPerPageChange}
                                className="border p-2 rounded ml-1"
                            >
                                {ITEMS_PER_PAGE_OPTIONS.map((option) => (
                                    <option key={option} value={option}>
                                        {option} per page
                                    </option>
                                ))}
                            </select>
                        </div>

                        {results.length > 0 ? (
                            <table className="w-full border-collapse border border-gray-300">
                                <thead className="bg-gray text-white">
                                    <tr>
                                        <th className="border p-2">Code</th>
                                        <th className="border p-2">Product Name</th>
                                        <th className="border p-2">UN No.</th>
                                        <th className="border p-2">IMCO</th>
                                        <th className="border p-2">CAS No.</th>
                                        <th className="border p-2">MSDS</th>
                                        <th className="border p-2">COAs</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {results.map((product, index) => (
                                        <tr key={index} className="odd:bg-gray-100">
                                            <td className="border p-2 font-bold">{product.hs_code}</td>
                                            <td className="border p-2">
                                                <Link to={`${config.appUrl}${product.category_slug}/${product.slug}`} className="text-title">
                                                    {product.product_name}
                                                </Link>
                                            </td>
                                            <td className="border p-2">{product.un_no}</td>
                                            <td className="border p-2">{product.imco_class}</td>
                                            <td className="border p-2">{product.cas_no}</td>
                                            <td className="border p-2 text-blue-500 cursor-pointer">MSDS</td>
                                            <td className="border p-2 text-blue-500 cursor-pointer">COAs</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <p>No results found.</p>
                        )}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchResults;
